import React, { createContext, useContext, useState } from 'react';

const VendorContext = createContext();

export const useVendor = () => {
  const context = useContext(VendorContext);
  if (!context) {
    throw new Error('useVendor must be used within a VendorProvider');
  }
  return context;
};

export const VendorProvider = ({ children }) => {
  const [vendorCounts, setVendorCounts] = useState({});
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refreshVendorCounts = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const updateVendorCount = (categorySlug, count) => {
    setVendorCounts(prev => ({
      ...prev,
      [categorySlug]: count
    }));
  };

  const value = {
    vendorCounts,
    refreshTrigger,
    refreshVendorCounts,
    updateVendorCount
  };

  return (
    <VendorContext.Provider value={value}>
      {children}
    </VendorContext.Provider>
  );
};

export default VendorContext;